import React from 'react';
import { Row, Col, Popover } from 'react-bootstrap';
import { Field } from 'redux-form';
import CheckBoxSelect from 'components/atoms/form/CheckBoxSelect';
import { DisabledDiv, HiddenBorderDiv } from 'components/atoms/form/UtilityDivs';
import DefaultChannelsBlock from 'components/molecules/DefaultChannelsBlock';
import CurrentImportantSettingsContainer from 'containers/forms/entities/CurrentImportantSettingsContainer';
import ChannelVisibilitySubHeading from 'components/molecules/ChannelVisibilitySubHeading';


const overrideBrandChannelHelpText = (<Popover
    id="override-brand-default-channels"
    placement="right"
    title="Override Brand Channel Visibility"
>
    Channel Visibility settings determine what channels will be visible in the dashboard's sidebar navigation.
    If you wish to overwrite the settings that are inherited from the brand, you can do so here.
</Popover>);

const shouldRenderEnabledChannelsOverlay = (props) => {
    if (props.selectedBrandId) {
        return !props.selectedOverrideBrandEnabledChannels;
    }
    return false;
};

const AvailableChannels = props => (
    <Row>
        <Col xs={12}>
            <CurrentImportantSettingsContainer>
                {({
                    selectedBrandId,
                    selectedOverrideBrandEnabledChannels
                }) => (
                    <HiddenBorderDiv hide={!props.selectedBrandId}>
                        {props.selectedBrandId ? (
                            <Field
                                name="meta.overrideBrand.enabledChannels"
                                label="Override Brand Channel Visibility"
                                type="checkbox"
                                component={CheckBoxSelect}
                                overlay={overrideBrandChannelHelpText}
                            />
                        ) : null}

                        <DisabledDiv sm={6} disablePointer={shouldRenderEnabledChannelsOverlay({
                            ...props,
                            selectedBrandId,
                            selectedOverrideBrandEnabledChannels
                        })}>
                            <Row>
                                <Col xs={12}>
                                    <ChannelVisibilitySubHeading marginTop={0} marginBottomModifier={10} />
                                </Col>
                            </Row>
                            <DefaultChannelsBlock />
                        </DisabledDiv>
                    </HiddenBorderDiv>
                )}
            </CurrentImportantSettingsContainer>
        </Col>
    </Row>
);

export default AvailableChannels;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/AvailableChannels.js